import { ReactNode } from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CourseSearch } from "./course-search";

export type CoursesHeaderProps = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  title: ReactNode | string;
};

export const CoursesHeader: FC<CoursesHeaderProps> = (props) => {
  const { t } = useTranslation();
  const { searchQuery, setSearchQuery, title } = props;
  return (
    <header className="mb-8 flex flex-col lg:flex-row lg:justify-between lg:items-center gap-y-6">
      <div className="flex flex-row items-center gap-4">
        <h1 className="text-xl sm:text-2xl md:text-3xl md:-mt-1">{title}</h1>
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="border hover:bg-gray-300 rounded-md border-gray-700 h-6
              px-2 text-sm flex flex-row items-baseline gap-2 md:pt-[1px]"
          >
            {t`courses.clearSearchButton`}{" "}
            <img src="/cross.svg" alt="" className="h-2 inline" />
          </button>
        )}
      </div>
      <CourseSearch onSearch={(x) => setSearchQuery(x)} />
    </header>
  );
};
